import { useNavigate  } from "react-router-dom";
import {useListView} from "../../core/ListViewProvider";
import {KTSVG} from "../../../../../../_metronic/helpers";

const UsersListToolbar = () => {
  const {setItemIdForUpdate} = useListView()
    const history = useNavigate ();

    const openAddUserModal = () => {
    setItemIdForUpdate(null)
  }

  return (
    <div className='d-flex justify-content-end' data-kt-user-table-toolbar='base'>
      {/*<PageListFilter />*/}

      {/* begin::Export */}
      {/*<link href={"/apps/Costumer-management/groupAdd"} className='btn btn-light-primary me-3'>افزودن گروهی</link>*/}
      <button type='button' className='btn btn-light-primary me-3' onClick={()=>{history("/apps/Page/edit");}} >
        <KTSVG path='/media/icons/duotune/arrows/arr076.svg'  className='svg-icon-2' />
        صفحه جدید
      </button>
      {/* end::Export */}


    </div>
  )
}

export {UsersListToolbar}
